import { render, staticRenderFns } from "./CourseTypeDialog.vue?vue&type=template&id=64b18368&scoped=true&"
import script from "./CourseTypeDialog.vue?vue&type=script&lang=js&"
export * from "./CourseTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b18368",
  null
  
)

export default component.exports